// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { warning } from 'react-notification-system-redux'
import { updateRenewalAdminHighlightedData } from 'redux/modules/projectTracker'

const toggleRenewalAdminHighlightedId = transactionId => (dispatch, getState) => {
  const { highlightedTransactionIds } = getState().projectTracker.renewalAdmin

  //if a user tries to select a path with "Awaiting User Action" status, a warning is shown.
  if (transactionId === 0) {
    dispatch(warning({
      message: `Paths with "Awaiting User Action" status cannot be selected.`,
    }))
    return
  }

  // determine if we are trying to remove this transaction or add it to the highlighted list.
  // if the transactionId is already in the highlightedTransactionIds,
  // then filter it out else add it to the list
  const newHighlightedTransactionIds = (
    highlightedTransactionIds.includes(transactionId)
      ? highlightedTransactionIds.filter(v => v !== transactionId)
      : [...highlightedTransactionIds, transactionId]
  )

  return dispatch(updateRenewalAdminHighlightedData(newHighlightedTransactionIds))
}

export default toggleRenewalAdminHighlightedId
